import { render } from "./ShareRequestItem.vue?vue&type=template&id=78564dea"
import script from "./ShareRequestItem.vue?vue&type=script&lang=js"
export * from "./ShareRequestItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__